export default __webpack_public_path__ + "static/media/male_01.d6f82abd.png";